import React from 'react'

import { usePlatformFeatureFlags } from '@components/utils/DashboardFeatureFlags/usePlatformFeatureFlags'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { useAdminModeContext } from '../../../../../App/providers/AdminModeProvider'
import type { ProductFormState } from '../../SingleProduct.types'
import { ProductShipping3PL } from './ProductShipping3PL'
import { ProductShippingBespoke } from './ProductShippingBespoke'
import { ProductShippingByCreator } from './ProductShippingByCreator'
import { ProductShippingNotConfigurable } from './ProductShippingNotConfigurable'
import { getShippingViewModel } from './viewModel/getShippingViewModel'

export const Shipping = () => {
  const { values } = useFormikContext<ProductFormState>()
  const { hasFeatureFlag } = usePlatformFeatureFlags()
  const { hasPermission } = useDashboardPermissions()
  const adminMode = useAdminModeContext()
  const featureEnabled =
    (hasFeatureFlag('assisted_product_shipping') &&
      hasPermission('products.thirdPartyLogistics.edit')) ||
    Boolean(adminMode?.isActive)

  const shippingViewModel = getShippingViewModel({
    values,
    featureEnabled,
  })

  if (shippingViewModel.view === 'SHIPPING_3PL') {
    return <ProductShipping3PL />
  }

  if (shippingViewModel.view === 'NO_SHIPPING') {
    return null
  }

  if (
    shippingViewModel.view === 'WEIGHT_BASED_SELF_SHIPPING' ||
    shippingViewModel.view === 'FLAT_SELF_SHIPPING'
  ) {
    return <ProductShippingByCreator />
  }

  if (shippingViewModel.view === 'BESPOKE_SHIPPING') {
    return <ProductShippingBespoke />
  }

  // TODO: LEGACY 3PL goes here as well (refactor after 3PL starts using new shipping form)
  // remove all fieldsets from this component after that as well

  return <ProductShippingNotConfigurable />
}
